import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobseekerService } from '../../shared/services/jobseeker.service';
import { CustomMessageService } from '@admin/core/message.service';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { Router } from '@angular/router';
import { jobseekerModerationRequest } from '../../shared/models/jobseeker-moderation.model';
import { LookupService } from '@admin/shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-jobseeker-moderation-buttons',
  templateUrl: './jobseeker-moderation-buttons.component.html',
  styleUrls: ['./jobseeker-moderation-buttons.component.less'],
  standalone: false,
})
export class JobseekerModerationButtonsComponent {
  @Input() jobseekerModerationId!: string;
  @Input() jobseekerId!: number;
  @Input() providerWebsiteId!: number;
  @Input() contactReset!: { [key: number]: string };
  @Input() experienceReset!: { [key: number]: string };
  @Input() educationReset!: { [key: number]: string };
  @Input() languageReset!: { [key: number]: string };
  @Input() documentReset!: { [key: number]: string };
  @Input() skillReset!: { [key: number]: string };
  @Output() updateDataEvent = new EventEmitter<any>();
  public providerWebsiteMap: { [index: string]: string } = {};

  constructor(
    private jobseekerService: JobseekerService,
    private translateService: TranslateService,
    private messageService: CustomMessageService,
    private router: Router,
    private lookupService: LookupService
  ) {}

  refreshPage() {
    this.updateDataEvent.emit();
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    lookupData.providerWebsiteList.forEach((providerWebsite) => {
      this.providerWebsiteMap[
        providerWebsite.value
      ] = `https://${providerWebsite.text}/`;
    });
  }

  onApprove(jobseekerModerationId) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    let data: jobseekerModerationRequest = {
      JobseekerModerationId: this.jobseekerModerationId,
      ContactResetMap: this.contactReset,
      WorkExperienceResetMap: this.experienceReset,
      EducationResetMap: this.educationReset,
      DocumentResetMap: this.documentReset,
      LanguageResetMap: this.languageReset,
      SkillResetMap: this.skillReset,
    };
    this.jobseekerService
      .approveJobseekerModeration(jobseekerModerationId, data)
      .subscribe((d: any) => {
        if (d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translateService.instant('message.SaveMessage'),
          });
          this.router.navigate(['./jobseekers/list']);
        } else if (!d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
        }
      });
  }

  onReject(jobseekerModerationId) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    this.jobseekerService
      .rejectJobseekerModeration(jobseekerModerationId, null)
      .subscribe((d: any) => {
        if (d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translateService.instant('message.SaveMessage'),
          });
          this.router.navigate(['./jobseekers/list']);
        } else if (!d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
        }
      });
  }
}
